import React from 'react';
import './RiddledInImagePowerupButton.css';

const RiddledInImagePowerupButton = ({
  onClick,
  disabled,
  isProcessing,
}) => {
  const isDisabled = Boolean(disabled) || Boolean(isProcessing);

  return (
    <div className="riddled-in-image-button-wrap">
      <button
        className={`riddled-in-image-button ${isDisabled ? 'disabled' : ''}`.trim()}
        onClick={onClick}
        disabled={isDisabled}
        aria-disabled={isDisabled}
      >
        <span className="label">{isProcessing ? 'Generating hint...' : 'Generate Image Hint'}</span>
      </button>
    </div>
  );
};

export default RiddledInImagePowerupButton;

